import React, { useEffect, useState } from 'react';

const today = new Date().toISOString().split('T')[0];

const DismissibleNotice = ({
  id,
  text,
  variant = 'orange', // default
}: {
  id: string;
  text: string;
  variant?: 'orange' | 'green';
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const dismissedDate = localStorage.getItem(`dismissed-${id}`);
    if (dismissedDate === today) {
      setVisible(false);
    }
  }, [id]);

  const handleClose = () => {
    localStorage.setItem(`dismissed-${id}`, today);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={`notice-container notice-container--${variant}`}>
      <p className="notice-text">{text}</p>
      <button onClick={handleClose} className="close-notice">
        <span>✖</span>
      </button>
    </div>
  );
};

export default DismissibleNotice;
